/**
 * Validates if a URL is a valid Google Maps URL
 */
export function validateGoogleMapsUrl(url: string): boolean {
  if (!url || typeof url !== 'string') {
    return false;
  }
  
  const trimmedUrl = url.trim();
  if (!trimmedUrl) {
    return false;
  }
  
  // Enhanced validation patterns
  const validPatterns = [
    /google\.com\/maps/i,
    /maps\.app\.goo\.gl/i,
    /goo\.gl\/maps/i,
    /maps\.google\.com/i,
    /maps\.google\.[a-z]{2,3}\/maps/i // Support other country domains
  ];
  
  return validPatterns.some(pattern => pattern.test(trimmedUrl));
}